import React, { useState } from 'react';
import axios from 'axios';

const Upload = () => {
    const [file, setFile] = useState(null);
    const [message, setMessage] = useState('');

    // ✅ Match the env variable you already have
    const API_BASE_URL = process.env.REACT_APP_API_URL; // e.g. https://api.admin.marsreel.com/api

    const handleUpload = async () => {
        if (!file) return alert('Please select a video file first');

        const formData = new FormData();
        formData.append('video', file);
        formData.append('uploadedBy', '667a61c2d368b44ada117bae'); // default user
        formData.append('session', '66c4e533baac9274737c59df');

        try {
            const res = await axios.post(`${API_BASE_URL}/videos/upload`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            setMessage(`✅ Success: ${res.data.video.videoUrl}`);
        } catch (err) {
            setMessage(`❌ Error: ${err.response?.data?.error || err.message}`);
        }
    };

    return (
        <div style={{ padding: 40, color: 'white', textAlign: 'center' }}>
            <h1>Upload Video</h1>
            <input type="file" accept="video/*" onChange={(e) => setFile(e.target.files[0])} />
            <button onClick={handleUpload} style={{ marginLeft: 20, padding: 10, backgroundColor: '#12c099', color: 'white', border: 'none', borderRadius: 5 }}>
                Upload
            </button>
            {message && <p>{message}</p>}
        </div>
    );
};

export default Upload;
